"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountriesAndRegionsOptions = void 0;
const getCountriesAndRegionsOptions = (countries) => {
    const countriesRegions = {};
    const countriesOptions = Object.values(countries).map((country) => {
        var _a;
        countriesRegions[country.id] =
            ((_a = country.regions) === null || _a === void 0 ? void 0 : _a.map((region) => ({
                value: region.id,
                label: region.name,
                autocomplete: region.iso2
            }))) || [];
        return {
            value: country.id,
            label: country.name,
            autocomplete: country.name
        };
    });
    return {
        countries: countriesOptions,
        regions: countriesRegions
    };
};
exports.getCountriesAndRegionsOptions = getCountriesAndRegionsOptions;
//# sourceMappingURL=getCountriesAndRegionsOptions.js.map